/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawat2Inputs */

const en_dropdrawat2 = /** @type {(inputs: Dropdrawat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw at`)
};

const de_dropdrawat2 = /** @type {(inputs: Dropdrawat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziehung`)
};

/**
* | output |
* | --- |
* | "Draw at" |
*
* @param {Dropdrawat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawat2 = /** @type {((inputs?: Dropdrawat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawat2(inputs)
	return de_dropdrawat2(inputs)
});
export { dropdrawat2 as "dropDrawAt" }